import { useState } from "react";
import { motion } from "framer-motion";
import { Chrome, Copy, X } from "lucide-react";
import { chromeIntent, copyLink, detectPlatform, isStandalone } from "../../lib/install";
import { getChat } from "../../lib/live";

const KEY = "fm_chrome_bar_off";
const shouldShow = () => {
  try { if (sessionStorage.getItem(KEY)) return false; } catch { /* ignore */ }
  return !isStandalone() && detectPlatform() === "inapp-android";
};

export const OpenChromeBar = ({ className = "" }) => {
  const [show, setShow] = useState(shouldShow);
  if (!show) return null;
  const close = () => { try { sessionStorage.setItem(KEY, "1"); } catch { /* ignore */ } setShow(false); };
  const chatting = !!getChat()?.hasSession();

  return (
    <motion.div data-testid="open-chrome-bar" className={`lz-push lz-chrome-bar ${className}`} initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}>
      <span className="lz-push-icon"><Chrome size={18} /></span>
      <div className="flex-1 min-w-0">
        <p className="text-[13.5px] leading-snug">
          {chatting ? <>Abra no <b>Chrome</b> para instalar nosso app. Sua conversa continua de onde parou.</>
            : <>Para uma experiência melhor e instalar nosso app, abra esta página no <b>Chrome</b>.</>}
        </p>
        <div className="flex gap-2 mt-2">
          <button type="button" data-testid="open-chrome-button" onClick={() => { window.location.href = chromeIntent(); }} className="lz-push-yes">Abrir no Chrome</button>
          <button type="button" data-testid="open-chrome-copy" onClick={() => copyLink("Chrome")} className="lz-push-yes lz-push-alt">
            <Copy size={13} /> Copiar link
          </button>
        </div>
      </div>
      <button type="button" data-testid="open-chrome-dismiss" onClick={close} className="lz-push-no self-start" aria-label="Fechar"><X size={16} /></button>
    </motion.div>
  );
};
